import { render, staticRenderFns } from "./edit_task.vue?vue&type=template&id=3e5bf348&scoped=true"
import script from "./edit_task.vue?vue&type=script&lang=js"
export * from "./edit_task.vue?vue&type=script&lang=js"
import style0 from "./edit_task.vue?vue&type=style&index=0&id=3e5bf348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5bf348",
  null
  
)

export default component.exports